app.factory('OrganizationalUnit', ['$http', function ($http) {
    var factory = {};
    var baseUrl = '/organizational-units';

    factory.getRoots = function () {
        return $http.get(baseUrl + '/roots')
            .then(function (resp) {
                return resp.data;
            });
    };

    factory.getChildren = function (parentId) {
        var url = baseUrl + '/' + parentId + '/children';

        return $http.get(url)
            .then(function (resp) {
                return resp.data;
            });
    };

    factory.createRoot = function (root) {
        var url = baseUrl + '/roots';

        return $http.post(url, root);
    };

    factory.createChild = function (parentId, unit) {
        var url = baseUrl + '/' + parentId + '/children';

        return $http.post(url, unit);
    };

    factory.change = function (id, data) {
        var url = baseUrl + '/' + id + '/name';

        return $http.put(url, data);
    };

    factory.changeParent = function (id, newParentId) {
        var url = baseUrl + '/' + id + '/parent';

        return $http.put(url, { parentId: newParentId });
    };

    factory.getById = function (id) {
        return $http.get(baseUrl + "/one/" + id).then(function (resp) {
            return resp.data
        })
    };

    factory.findByQuery = function (query) {
        return $http.post(baseUrl + "/search",
            query
        ).then(function (resp) {
            return resp.data
        })
    };

    factory.addPosition = function (params) {
        return $http.post(baseUrl + "/position/add", {
            unit: params.unitId,
            name: params.name,
            isRoot: params.isRoot
        }).then(function (resp) {
            return resp.data;
        });
    };

    factory.delete = function (id) {
        var url = baseUrl + '/' + id;

        return $http.delete(url);
    };

    factory.getAll = function () {
        return $http.get(baseUrl + '/')
            .then(function (resp) {
                return resp.data;
            });
    };

    factory.getVacations = function () {
        return $http.get(baseUrl + '/vacations')
            .then(function (resp) {
                return resp.data;
            });
    };

    factory.getUnitById = function (unitId) {
        return $http.get(baseUrl + "/" + unitId).then(function (resp) {
            return resp.data;
        });
    };
    return factory;
}]);
